import LinkifyReact from 'linkify-react';

const baseLinkifyOptions = {
    target: '_blank',
    rel: 'noopener noreferrer',
    className: 'linkify-link',
    defaultProtocol: 'https',
    attributes: {
        style: {
            color: '#2563eb',
            textDecoration: 'none',
            borderBottom: '1px solid transparent',
            transition: 'border-color 120ms ease-in-out',
        },
        onMouseEnter: (e: React.MouseEvent<HTMLAnchorElement>) => {
            e.currentTarget.style.borderBottomColor = '#2563eb';
        },
        onMouseLeave: (e: React.MouseEvent<HTMLAnchorElement>) => {
            e.currentTarget.style.borderBottomColor = 'transparent';
        },
    },
};

interface LinkifyProps {
    children: React.ReactNode;
    /**
     * linkify-react recurses into every child element by default, so wrapping content that
     * already contains real <a> tags (e.g. markdown-rendered links) re-linkifies their text and
     * produces nested anchors. Pass ['a'] in that specific case only -- every other Linkify
     * consumer wraps plain strings with no <a> children, so this stays opt-in rather than a
     * global default.
     */
    ignoreTags?: string[];
}

export const Linkify = ({ children, ignoreTags }: LinkifyProps) => {
    if (!children) return null;
    const options = ignoreTags ? { ...baseLinkifyOptions, ignoreTags } : baseLinkifyOptions;
    return <LinkifyReact options={options}>{children}</LinkifyReact>;
};
